import { Pipe, PipeTransform } from '@angular/core';
import { CardType } from '@app/enums/card-type.enum';
import { Learning_Type } from '@app/enums/learning-type.enum';

@Pipe({
  name: 'cardType',
  standalone: false,
})
export class CardTypePipe implements PipeTransform {
  /**
   * Return transformed learning type string to new display type
   * @param learningType - learning type to transform to new display type
   * @returns - transformed learning type string
   */
  public transform(learningType: string): string {
    switch (learningType) {
      case Learning_Type.SUBSCRIPTION:
        return CardType.SUBSCRIPTION;
      case Learning_Type.E_LEARNING:
      case Learning_Type.QUICK_LEARNING:
      case Learning_Type.WORKSHOP:
        return CardType.COURSE;
      case Learning_Type.CERTIFICATION_EXAM:
        return CardType.CERTIFICATION_EXAM;
      case Learning_Type.SELF_STUDY:
        return CardType.COURSE;
      case Learning_Type.WEBINAR:
        return CardType.COURSE;
      case Learning_Type.INSTRUCTOR_LED:
      case Learning_Type.INSTRUCTOR_LED_IN_PERSON:
      case Learning_Type.INSTRUCTOR_LED_VIRTUAL:
      case Learning_Type.VIRTUAL:
      case Learning_Type.IN_PERSON:
        return CardType.COURSE;
      default:
        return CardType.COURSE;
    }
  }
}
